{ "closeAria": "Закрыть", "historyAria": "История обращений", "supportTitle": "Поддержка" }
